export default "__VITE_ASSET__1b40a9f1__"